import callApi from "../../api/axios";

export const loginApi = (values) => {
  return callApi({ method: "POST", url: "auth/sign-in", data: values });
};

export const registerPartnerApi = (values) => {
  return callApi({ method: "POST", url: "partners/register", data: values });
};

export const forgotPasswordApi = (values) => {
  return callApi({ method: "POST", url: "auth/forgot-password", data: values });
};

export const resetPasswordApi = (values) => {
  return callApi({ method: "POST", url: "auth/reset-password", data: values });
};
